/* eslint-disable max-len */
export default [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "logout" */ '../views/Home.vue'),
    },
    {
        path: '/explorar_carreras',
        name: 'explorar carreras',
        component: () => import(/* webpachChunkName: "explorar_carreras" */ '../views/Explore.vue'),
    },
    {
        path: '/mis-favoritos',
        name: 'mis-favoritos',
        component: () => import(/* webpackChunkName: "favorites" */ '../views/Favorites/index.vue'),
    },
    {
        path: '/explorador',
        name: 'explorer',
        component: () => import(/* webpackChunkName: "explorador" */ '../views/Explorer/index.vue'),
        // children: [
        //     {
        //         path: '/',
        //         name: 'explorador',
        //         component: () => import(/* webpackChunkName: "explorador-list" */ '../views/Careers/List.vue'),
        //     },
        //     {
        //         path: ':id',
        //         name: 'explorador-show',
        //         component: () => import(/* webpackChunkName: "explorador-show" */ '../views/Careers/Show.vue'),
        //     },
        // ]
    },
    {
        path: '/welcome_video',
        name: 'video',
        component: () => import(/* webpackChunkName: "gender" */ '../views/Video.vue'),
    },
    // {
    //     path: '/gender',
    //     name: 'gender',
    //     component: () => import(/* webpackChunkName: "gender" */ '../views/InitialQuestions/Gender.vue'),
    // },
    {
        path: '/regions',
        name: 'regions',
        component: () => import(/* webpackChunkName: "region" */ '../views/InitialQuestions/Regions.vue'),
    },
    {
        path: '/ana',
        name: 'ana',
        component: () => import(/* webpackChunkName: "ana" */ '../views/InitialQuestions/Ana.vue'),
    },
    {
        path: '/areas',
        name: 'areas',
        component: () => import(/* webpackChunkName: "areas" */ '../views/InitialQuestions/Areas.vue'),
    },
    {
        path: '/careers',
        name: 'careers',
        component: () => import(/* webpackChunkName: "careers" */ '../views/Careers.vue'),
    },
    {
        path: '/contact',
        name: 'contact form with ana',
        component: () => import(/* webpachChunkName: "contact" */ '../views/Contact.vue'),
    },
    {
        path: '/data-source',
        name: 'fuente de datos',
        component: () => import(/* webpachChunkName: "data-source" */ '../views/DataSource.vue'),
    },
    {
        path: '/about',
        name: 'sobre nosotros',
        component: () => import(/* webpachChunkName: "data-source" */ '../views/About.vue'),
    },
    {
        path: '/password_reset',
        name: 'password_reset',
        component: () => import(/* webpackChunkName: "404" */ '../views/PasswordResetDialog.vue'),
    },
    {
        path: '*',
        component: () => import(/* webpackChunkName: "404" */ '../views/NotFound.vue'),
    },
];
